import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    container: {
        whiteSpace: 'nowrap',
    },
    value: {
        fontWeight: 'bold',
    },
});

type PropertyInfoItemProps = {
    title: string;
    value: string | number;
};

export const PropertyInfoItem = ({ title, value }: PropertyInfoItemProps) => {
    const classes = useStyles();

    return (
        <Grid container justifyContent="space-between" alignItems="center" wrap="nowrap" className={classes.container}>
            <Grid item>
                <Typography color="primary" variant="body2">{title}</Typography>
            </Grid>
            <Grid item>
                <Typography color="primary" variant="body2" className={classes.value}>{value}</Typography>
            </Grid>
        </Grid>
    );
};
